import { isLyrraOne } from '@/lib/platform';
import '@/styles/lyrraone-marketing-pages.css';

interface LyrraOneModulePageProps {
  title?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

/** Conteneur pleine largeur pour les pages Marketing & vente (LyrraOne). */
export const lyrraOneMarketingShellClass = 'lo-marketing-page w-full min-w-0 space-y-5';

export function LyrraOneGate({ children }: { children: React.ReactNode }) {
  if (!isLyrraOne()) {
    return (
      <div className="p-6">
        <p className="text-sm text-gray-500">Cette fonctionnalité est disponible sur LyrraOne.</p>
      </div>
    );
  }
  return <>{children}</>;
}

export function LyrraOneModulePage({ title, description, children }: LyrraOneModulePageProps) {
  return (
    <LyrraOneGate>
      <div className={lyrraOneMarketingShellClass}>
        {title ? (
          <header className={`lo-marketing-page__header ${description ? 'space-y-1' : undefined}`}>
            <h1>{title}</h1>
            {description ? <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p> : null}
          </header>
        ) : null}
        {children}
      </div>
    </LyrraOneGate>
  );
}

export function LoCard({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`lo-card rounded-xl p-4 ${className}`}>
      {children}
    </div>
  );
}

export function LoEmpty({ message }: { message: string }) {
  return <p className="lo-empty">{message}</p>;
}

export function LoFormRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="block space-y-1">
      <span className="lo-form-label">{label}</span>
      {children}
    </div>
  );
}

export const inputClass = 'lo-input';

export const btnPrimary =
  'lo-btn-primary disabled:opacity-50';

export const btnSecondary =
  'lo-btn-secondary disabled:opacity-50';
